const phoneLinkFormatter = (phone) => {
    if (!phone) {
        return null;
    }

    let phoneLink = phone.replace(/\D/g, "");
    phoneLink = phoneLink.substring(0, 10);

    return `tel:+1${phoneLink}`;
};

export default phoneLinkFormatter;
